import {
    faEye,
    faEyeSlash,
} from '@awesome.me/kit-eee5f32034/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from '@onwardtravelsolutions/package-react/Components';
import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';
import {
    useFieldFocus,
    useToggle,
} from '@onwardtravelsolutions/package-react/Hooks';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import React from 'react';
import { getValidation } from '../../Utilities/validation';
import Field from './Field';
import FieldValidation from './FieldValidation';

type PasswordFieldProps = {
    id: string;
    label?: string;
    className?: string;
    children?: React.ReactNode;
    status?: ValidationStatus;
    notices?: Notice[];
    isDirty?: boolean;
    value?: string;
    setValue?: (value: any) => void;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function PasswordField({
    id,
    children,
    label = null,
    className = null,
    autoComplete = 'current-password',
    status,
    notices = [],
    value = '',
    onChange = null,
    setValue = null,
    isDirty = false,
    ...rest
}: PasswordFieldProps) {
    const [isVisible, toggleVisiblity] = useToggle();
    const { isFocused, focusHandlers } = useFieldFocus(false);
    const validation = getValidation(status);

    return (
        <Field id={id} label={label} className={className}>
            <FieldValidation
                id={id}
                status={status}
                notices={notices}
                showNotices={isFocused}
            >
                <Input
                    {...{
                        id: `field-${id}`,
                        type: isVisible ? 'text' : 'password',
                        placeholder: '●●●●●●●●',
                        className: `inset-shadow-sm bg-gray-50 focus:outline-none border-2 dark:bg-neutral-700 border ${validation.borderClasses} rounded w-full dark:text-neutral-200`,
                        autoComplete,
                        value,
                        onChange:
                            onChange ??
                            ((event: React.ChangeEvent<HTMLInputElement>) =>
                                setValue?.(event.currentTarget.value)),
                        ...focusHandlers,
                        ...rest,
                    }}
                />
                <Button
                    onClick={toggleVisiblity}
                    className={
                        'transition-opacity w-6 h-5 dark:text-neutral-200 block absolute right-2 top-1.5 cursor-pointer opacity-60 hover:opacity-100 text-center'
                    }
                >
                    <FontAwesomeIcon
                        fontSize={18}
                        icon={isVisible ? faEyeSlash : faEye}
                    />
                </Button>
            </FieldValidation>
        </Field>
    );
}
